import axios, { type AxiosResponse } from "axios";

export const get = async <T>(
    url: string,
    secret?: string,
    params?: unknown
): Promise<AxiosResponse<T>> => {
    return await axios<T>({
        method: "get",
        url,
        params,
        headers: {
            "Content-Type": "application/json",
            "X-API-Key": secret,
        },
    });
};
